import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './styles';
import { ITotals } from './totals.interface';

export const Totals = (props: ITotals) => {
  const classes = useStyles();
  const {
    totalAddReturnInvoice,
    totalAmount,
    totalAmountAdvanceDiscount,
    totalAmountReturnInvoice,
    totalAmountToPay,
    totalDownloadDiscountValue,
    totalGCDiscountValue,
    totalResaleDiscountValue,
    totalLateChange,
    totalNoShowPenalty,
    totalPaidValue,
    totalRows
  } = props.totals;

  const currencyBr = new Intl.NumberFormat('pt-BR', {
    currency: 'BRL',
    style: 'currency'
  });

  return (
    <div>
      <Paper className={classes.root}>
        <Typography variant="h6" component="h6" style={{ marginLeft: 10 }}>
          Totalizadores financeiros
        </Typography>
        <div style={{ marginLeft: 8 }}>
          <Grid container spacing={0}>
            <Grid item sm={3} xs={2}>
              <Typography component="p">{'Qtde NF emitida: '}</Typography>

              <Typography component="p">{'Valor total de NF: '}</Typography>

              <Typography component="p">{'Valor total NF Devolução: '}</Typography>

              <Typography component="p">{'Valor total Acrésc. Devolução: '}</Typography>

              <Typography component="p">{'Valor total Desc. Descarga: '}</Typography>

              <Typography component="p">{'Valor total Desc. Revenda: '}</Typography>
            </Grid>

            <Grid item sm={2} xs={2}>
              <Typography component="p">
                <b>{totalRows}</b>
              </Typography>

              <Typography component="p">
                <b>{currencyBr.format(totalAmount)}</b>
              </Typography>

              <Typography component="p">
                <b>{currencyBr.format(totalAmountReturnInvoice)}</b>
              </Typography>

              <Typography component="p">
                <b>{currencyBr.format(totalAddReturnInvoice)}</b>
              </Typography>

              <Typography component="p">
                <b>{currencyBr.format(totalDownloadDiscountValue)}</b>
              </Typography>

              <Typography component="p">
                <b>{currencyBr.format(totalResaleDiscountValue)}</b>
              </Typography>
            </Grid>

            <Grid item sm={1} xs={1}></Grid>

            <Grid item sm={4} xs={3}>
              <Typography component="p">{'Valor total Outros Desc.: '}</Typography>

              <Typography component="p">{'Valor total Desc. Antecipação: '}</Typography>

              <Typography component="p">{'Valor total Desc. NoShow: '}</Typography>

              <Typography component="p">{'Valor total Desc. Alteração Tardia: '}</Typography>

              <Typography component="p">{'Valor total Pago: '}</Typography>

              <Typography component="p">{'Valor total a Receber: '}</Typography>
            </Grid>

            <Grid item sm={2} xs={2}>
              <Typography component="p">
                <b>{currencyBr.format(totalGCDiscountValue)}</b>
              </Typography>

              <Typography component="p">
                <b>{currencyBr.format(totalAmountAdvanceDiscount)}</b>
              </Typography>

              <Typography component="p">
                <b>{currencyBr.format(totalNoShowPenalty)}</b>
              </Typography>

              <Typography component="p">
                <b>{currencyBr.format(totalLateChange)}</b>
              </Typography>

              <Typography component="p">
                <b>{currencyBr.format(totalPaidValue)}</b>
              </Typography>

              <Typography component="p">
                <b>{currencyBr.format(totalAmountToPay)}</b>
              </Typography>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </div>
  );
};
